import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { guardarSpei } from '../../actions/auth';
import { ProgressBar } from '../shared/ProgressBar';
import { esMexico, BANCOS_MEXICO } from '../../helpers/util';
import Swal from 'sweetalert2';

export const PasoAnticipo = ({ siguiente, anterior, setManejaAnticipo }) => {
    const dispatch = useDispatch();
    const { zonaHoraria } = useSelector(state => state.auth);
    const esMx = esMexico(zonaHoraria);

    const [cobra, setCobra] = useState(null); // true | false
    const [nombre, setNombre] = useState('');
    const [banco, setBanco] = useState('');
    const [clabe, setClabe] = useState('');
    const [cargando, setCargando] = useState(false);

    const handleClabe = (val) => {
        setClabe(val.replace(/\D/g, '').slice(0, 18));
    };

    const handleContinuar = async () => {
        if (cobra === null) {
            Swal.fire('Falta seleccionar', '¿Cobras anticipo o no?', 'warning');
            return;
        }
        if (cobra) {
            if (!nombre.trim()) { Swal.fire('Falta el nombre', 'Escribe el nombre del titular de la cuenta.', 'warning'); return; }
            if (!banco) { Swal.fire('Falta el banco', 'Selecciona tu banco.', 'warning'); return; }
            if (clabe.length !== 18) { Swal.fire('CLABE inválida', 'La CLABE interbancaria debe tener exactamente 18 dígitos.', 'warning'); return; }
        }
        setCargando(true);
        try {
            const spei = cobra
                ? { a_nombre_de: nombre.trim(), banco, clabe_o_tarjeta: clabe }
                : { a_nombre_de: 'X', banco: 'X', clabe_o_tarjeta: '000000000000000000' };
            await dispatch(guardarSpei(spei));
            setManejaAnticipo(cobra);
            siguiente();
        } catch (e) {
            Swal.fire('Error', 'No se pudo guardar. Intenta de nuevo.', 'error');
        } finally {
            setCargando(false);
        }
    };

    // Si no es México, saltarse este paso
    if (!esMx) {
        siguiente();
        return null;
    }

    return (
        <div className="app-container">
            <div className="app-header">
                <h1>Pagos y anticipos</h1>
                <p>Paso 3 de 4</p>
            </div>
            <ProgressBar paso={3} />

            <div className="screen-body">
                <div className="info-box" style={{ marginTop: 0 }}>
                    <div className="info-box-title">¿Qué es un anticipo?</div>
                    <div className="info-box-body">
                        Es un pago que pides a tus clientas para confirmar la cita. Así evitas cancelaciones de último momento.<br /><br />
                        <strong>Te recomendamos activar esta opción solo si ya venías cobrando anticipo con tus clientas. Si es algo nuevo para ellas, podría hacer que duden antes de reservar — y si no envían el pago a tiempo, el sistema cancela su espacio automáticamente.</strong>
                    </div>
                </div>

                <div className="field-label" style={{ marginTop: 16 }}>¿Cobras anticipo para reservar?</div>
                <div className="option-grid">
                    <div
                        className={`option-card ${cobra === true ? 'selected' : ''}`}
                        onClick={() => setCobra(true)}
                    >
                        Sí, cobro anticipo
                    </div>
                    <div
                        className={`option-card ${cobra === false ? 'selected' : ''}`}
                        onClick={() => setCobra(false)}
                    >
                        No por ahora
                    </div>
                </div>

                {cobra === true && (
                    <>
                        <div className="info-box" style={{ marginTop: 12 }}>
                            <div className="info-box-body">
                                Tus clientas te enviarán el anticipo por transferencia. Agrega tu CLABE para recibirlo.
                            </div>
                        </div>

                        <div className="field-label">Nombre del titular de la cuenta</div>
                        <input
                            className="field-input"
                            placeholder="Como aparece en tu banco"
                            value={nombre}
                            onChange={e => setNombre(e.target.value)}
                        />

                        <div className="field-label">Banco</div>
                        <select
                            className="field-input"
                            value={banco}
                            onChange={e => setBanco(e.target.value)}
                        >
                            <option value="">Selecciona tu banco</option>
                            {BANCOS_MEXICO.map(b => (
                                <option key={b} value={b}>{b}</option>
                            ))}
                        </select>

                        <div className="field-label">CLABE interbancaria</div>
                        <input
                            className="field-input"
                            placeholder="18 dígitos"
                            type="tel"
                            inputMode="numeric"
                            value={clabe}
                            onChange={e => handleClabe(e.target.value)}
                            maxLength={18}
                        />
                        <p className={`field-${clabe.length === 18 ? 'hint' : clabe.length > 0 ? 'error' : 'hint'}`}>
                            {clabe.length === 18
                                ? '✓ CLABE válida'
                                : clabe.length > 0
                                    ? `${clabe.length}/18 dígitos`
                                    : 'Solo números, sin espacios ni guiones'}
                        </p>
                    </>
                )}

                {cobra === false && (
                    <div className="info-box" style={{ marginTop: 12 }}>
                        <div className="info-box-body">
                            Podrás activar los anticipos después desde la sección de configuración de tu negocio.
                        </div>
                    </div>
                )}
            </div>

            <div className="screen-footer">
                <button className="btn-primary" onClick={handleContinuar} disabled={cargando || cobra === null}>
                    {cargando ? 'Guardando...' : 'Continuar'}
                </button>
                <button className="btn-secondary" onClick={anterior}>Volver</button>
            </div>
        </div>
    );
};
